import React from 'react'
import PropTypes from 'prop-types'

import Confirm from 'views/confirm/confirm'
import { localize, localizeWithVars } from 'helpers/translator/localize'

const NotEnoughSpaceConfirm = props => {
	const getTitle = () => props.shouldShowNewTitle ? localizeWithVars('paywalls_not_enough_space', { maxStorage: props.maxStorage }) : props.offerMessage
	const getButtonTwoText = () => props.shouldOfferUpgrade ? localize('paywalls_not_enough_space_upgrade') : localize(('paywalls_not_enough_space_contact'))

	return (
		<Confirm
			btOne={localize('action_button_nothanks')}
			btTwo={getButtonTwoText()}
			alertTitle={getTitle()}
			alertMessage=''
			actionButtonType={0}
			centeredTitle={true}
			actionOne={props.handleNotNowSelected}
			actionTwo={props.handleConfirmSelected}
			closeAction={props.handleCloseConfirm}
		/>
	)
}

NotEnoughSpaceConfirm.defaultProps = {
	maxStorage: '',
	offerMessage: '',
}

NotEnoughSpaceConfirm.propTypes = {
	handleNotNowSelected: PropTypes.func.isRequired,
	handleConfirmSelected: PropTypes.func.isRequired,
	handleCloseConfirm: PropTypes.func.isRequired,
	shouldShowNewTitle: PropTypes.bool.isRequired,
	shouldOfferUpgrade: PropTypes.bool.isRequired,
	maxStorage: PropTypes.string,
	offerMessage: PropTypes.string,
}

export default NotEnoughSpaceConfirm
